<div class="p-inputgroup" [class.p-float-label]="float" class="p-inputgroup currency-control_wrapper">
  <input
    type="text"
    [formControl]="control"
    id="float-input"
    autocomplete="off"
    (click)="onTouched(control.value)"
    [placeholder]="float ? '' : placeholder"
    (focus)="onFocus()"
    (blur)="onBlur($event)"
    class="currency-control_wrapper_input"
    pInputText
    [jmlAutoSelect]="autoSelect"
  />
  <label *ngIf="float" for="float-input">{{ placeholder }}</label>
  <span class="p-inputgroup-addon">{{ currency$ | async }}</span>
</div>
